import { useMutation, useQuery } from "@apollo/client";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SubmitButton from "../../../../components/common/SubmitButton";
import CustomFormGroup from "../../../../components/form/CustomFormGroup";
import CustomSelect from "../../../../components/form/CustomSelect";
import { CREATE_MEMBER } from "../../../../graphql/mutations/management";
import {
  GET_MEMBER_LIST,
  GET_STAFF_LIST,
} from "../../../../graphql/queries/management";
import {
  clearFormMember,
  clearSelectedStaff,
  onChangeMember,
} from "../../../management/redux/managementSlice";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/common/CustomErrorMessage";

const MemberForm = ({ handleClose }) => {
  const dispatch = useDispatch();
  const management = useSelector((state) => state.management);
  const { createFormMember } = management;
  const { data } = useQuery(GET_STAFF_LIST);

  const options = data?.staffList?.map((s) => ({
    value: s.id,
    label: s.fullname,
  }));

  const handleChangeStaff = (e) =>
    dispatch(onChangeMember({ ...createFormMember, customerOf: e.value }));

  const [createMember, { loading: loadingCreate }] = useMutation(
    CREATE_MEMBER,
    {
      variables: {
        input: {
          username: createFormMember.username,
          password: createFormMember.password,
          passwordConfirm: createFormMember.passwordConfirm,
          nickname: createFormMember.nickname,
          customerOf: createFormMember.customerOf,
          isTestUser: createFormMember.isTestUser,
        },
      },
      refetchQueries: [{ query: GET_MEMBER_LIST }],
      onCompleted: (data) => {
        if (data) {
          handleClose();
          showSuccessToast();
          dispatch(clearFormMember());
        }
      },
      onError(err) {
        showErrorToast(err.message);
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    createMember();
  };

  const handleChange = (e) => {
    dispatch(
      onChangeMember({
        ...createFormMember,
        [e.target.name]: e.target.value,
      })
    );
  };

  const clearSelected = () => dispatch(clearSelectedStaff());

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomFormGroup
        label="ໝາຍເລກບັນຊີ"
        name="username"
        onChange={handleChange}
        type="text"
        value={createFormMember.username}
        placeholder="ໝາຍເລກບັນຊີ"
        errorParam="username"
        required={true}
      />
      <CustomFormGroup
        label="ຊື່ຫຼິ້ນ"
        name="nickname"
        onChange={handleChange}
        type="text"
        value={createFormMember.nickname}
        placeholder="ຊື່ຫຼິ້ນ"
        errorParam="nickname"
        required={true}
      />
      <CustomFormGroup
        label="ລະຫັດຜ່ານ"
        name="password"
        onChange={handleChange}
        type="text"
        value={createFormMember.password}
        placeholder="ລະຫັດຜ່ານ"
        errorParam="password"
        required={true}
      />
      <CustomFormGroup
        label="ຢືນຢັນລະຫັດຜ່ານ"
        name="passwordConfirm"
        onChange={handleChange}
        type="text"
        value={createFormMember.passwordConfirm}
        placeholder="ຢືນຢັນລະຫັດຜ່ານ"
        errorParam="passwordConfirm"
        required={true}
      />
      <Form.Label>ເລືອກພະນັກງານ</Form.Label>
      <Form.Group className="mb-3">
        <CustomSelect
          options={options}
          handleChange={handleChangeStaff}
          selected={createFormMember.customerOf}
          placeholder="-- ເລືອກພະນັກງານ--"
          clearSelected={clearSelected}
        />
      </Form.Group>
      <div className="text-center">
        <SubmitButton loading={loadingCreate} />
      </div>
    </Form>
  );
};

export default MemberForm;
